import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import 'core/overlay/OverlayDisplay.scss';

export enum OverlayMode {
    Spinner = 'spinner',
    Skeleton = 'skeleton',
}

export interface Props {
    className?: string;
    mode?: 'spinner' | 'skeleton';
}

export const OverlayDisplay: FunctionComponent<Props> = ({ className, mode = OverlayMode.Spinner }) => {
    const { t } = useTranslation('core');
    const overlayClassnames = classnames(
        'r4e-overlay',
        {
            'spinner-mode': mode === OverlayMode.Spinner,
            'skeleton-mode': mode === OverlayMode.Skeleton,
        },
        className,
    );

    return (
        <div className={overlayClassnames} title={t('CONTENT_LOADING')}>
            {mode === 'spinner' ? <i className="spinner icon-spinner" /> : null}
        </div>
    );
};
